module.exports = __webpack_public_path__ + "img/calculator.1d08fbbc.png";